import { render, staticRenderFns } from "./yjfk.vue?vue&type=template&id=07a4cf98&scoped=true&"
import script from "./yjfk.vue?vue&type=script&lang=js&"
export * from "./yjfk.vue?vue&type=script&lang=js&"
import style0 from "./yjfk.vue?vue&type=style&index=0&id=07a4cf98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4cf98",
  null
  
)

export default component.exports